import { DEFAULT_TIME_ZONE } from '@framework/timezone/constants';
import { DEFAULT_COUNTRY_CODE, EVERCALL_EVENT_TYPE_OPTIONS } from '../constants';
import { DIAL_IN_COUNTRY_FOR_OPTIONS } from '../DialInCountriesFieldArray/constants';

import { getNowDateRounded } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoForm/helpers';
import { getDefaultTimeZone, getTimeZoneOption } from '@framework/timezone/helpers';
import getUnixTimestamp from '@framework/date-helpers/getUnixTimestamp';

import { CallFormInstance, ICallDetailsFormValues } from '../interfaces';
import { ITimezone } from '@framework/timezone/vo/Timezone';
import { IDialInCountry } from '@evercall/domain/vo/DialInCountry';

export const getCallDetailsInitialValues = (
  timeZoneList: ITimezone[],
  countryList: IDialInCountry[],
  instance: CallFormInstance = CallFormInstance.ScheduleYourCall,
): ICallDetailsFormValues => {
  const defaultCountry = countryList.find((country) => country.code === DEFAULT_COUNTRY_CODE);
  const defaultTimeZone = getDefaultTimeZone(timeZoneList) || DEFAULT_TIME_ZONE;
  const now = getUnixTimestamp(getNowDateRounded(defaultTimeZone.timeZone));

  const isDmPortal = instance === CallFormInstance.CallSettingsForm;
  return {
    name: '',
    transactionTypeId: null,
    estimatedDuration: '',
    approximateNumberOfParticipants: '',
    dateAt: now,
    timeAt: now,
    dialInCountries: [
      {
        countryFor: DIAL_IN_COUNTRY_FOR_OPTIONS.SPEAKERS_AND_PARTICIPANTS,
        countryId: {
          value: defaultCountry.id,
          label: defaultCountry.name,
          countryCode: defaultCountry.code,
          phoneCode: defaultCountry.phoneCode || '',
        },
        countryDisplay: !!isDmPortal,
      },
    ],
    eventTypeId: EVERCALL_EVENT_TYPE_OPTIONS[0],
    timeZoneId: timeZoneList.length
      ? getTimeZoneOption(defaultTimeZone)
      : null,
  };
};

export default getCallDetailsInitialValues;
